import { render, staticRenderFns } from "./PolymorphicReferenceCardIndex.vue?vue&type=template&id=af0a07b2&"
import script from "./PolymorphicReferenceCardIndex.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports